import React, { useEffect, useState, useRef, useCallback, useMemo, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import {
  IconSearch,
  IconBarcode,
  IconAdjustmentsHorizontal,
  IconChevronDown,
  IconChevronUp,
  IconCalendarTime,
  IconReload,
  IconLayoutGrid,
  IconTable,
  IconEye,
  IconEyeOff,
  IconTrash,
  IconCheck,
  IconX,
  IconCopy,
  IconBuildingStore,
  IconChevronLeft,
  IconChevronRight,
  IconScale,
  IconPrinter,
  IconTransferIn,
  IconTransferOut,
  IconRefresh,
  IconInbox,
  IconPlus,
} from '@tabler/icons-react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import { toast } from 'react-toastify';
import { PhotoView } from 'react-photo-view';

import Layouts from '../layouts/Layouts';
import { getAuthorizationHeader, http } from '../config/http';
import { resolveItemImageUrl } from '../utils/itemImage';
import { DinamicTitle } from '../utils/DinamicTitle';
import { useMasterData } from '../context/MasterDataContext';

// Modals
import DetailItem from './Modal/DetailItem';
import EditItem from './Modal/EditItem';
import InputBarang from '../components/Admin/InputBarang';
import ConfirmationDeleteItem from '../components/Admin/ConfirmationDeleteItem';
import PrintBandrol from '../components/Admin/PrintBandrol';
import ModalTransferAntarToko from '../components/Admin/ModalTransferAntarToko';
import TransferBarangToCabang from '../components/Admin/TransferBarangToCabang';
import TransferBanyakBarang from '../components/Admin/PindahBarangBanyak';
import HapusBanyakBarang from '../components/Admin/HapusBanyakBarang';
import PindahBakiBanyak from '../components/Admin/PindahBakiBanyak';
import LoadingIndicator from '../components/LoadingIndicator';

function ListItemAdminV2() {
  const navigate = useNavigate();
  const user = localStorage.getItem('role');
  const isOwnerAdminVerifikator = user === 'owner' || user === 'admin' || user === 'verifikator';

  // ═══ Master Data ═══
  const { kategoriList = [], cabangList = [], bakiList = [], karatList = [] } = useMasterData() || {};
  const [kategoriLocal, setKategoriLocal] = useState([]);
  const [cabangLocal, setCabangLocal] = useState([]);

  const kategori = kategoriList && kategoriList.length > 0 ? kategoriList : kategoriLocal;
  const cabang = cabangList && cabangList.length > 0 ? cabangList : cabangLocal;
  const karatOptions = karatList && karatList.length > 0 ? karatList : [16, 17, 18, 19, 20, 21, 22, 23, 24];
  const bakiOptions = bakiList && bakiList.length > 0 ? bakiList : Array.from({ length: 20 }, (_, i) => i + 1);

  const etalaseOptions = useMemo(() => {
    return (cabang || []).filter(
      (cb) => (cb.is_toko === 1 || cb.is_toko === true) && !cb.nama_cabang?.toLowerCase().includes('brankas')
    );
  }, [cabang]);

  // ═══ View Mode State (Cards on mobile/tablet, Table toggleable) ═══
  const [viewMode, setViewMode] = useState('cards'); // 'cards' | 'table'

  // ═══ Data & Pagination State ═══
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState('1');
  const [lastPage, setLastPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jmlBarang, setJmlBarang] = useState(0);
  const [jmlBerat, setJmlBerat] = useState(0);
  const [totalModal, setTotalModal] = useState(0);
  const [totalModalFilter, setTotalModalFilter] = useState(0);

  // ═══ Filters State ═══
  const [search, setSearch] = useState('');
  const [scanInput, setScanInput] = useState('');
  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const [selectedBaki, setSelectedBaki] = useState([]);
  const [selectedKarat, setSelectedKarat] = useState([]);
  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');
  const [selectStatus, setSelectStatus] = useState('');
  const [selectCabang, setSelectCabang] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // ═══ Collapsible Filter & Dropdown States ═══
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isOpenKarat, setIsOpenKarat] = useState(false);
  const [isOpenBaki, setIsOpenBaki] = useState(false);
  const karatDropdownRef = useRef(null);
  const bakiDropdownRef = useRef(null);

  // ═══ Selection State (Multi-page retention) ═══
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectPindahItems, setSelectPindahItems] = useState([]);
  const [showSelectedPreview, setShowSelectedPreview] = useState(false);
  const [copyItemId, setCopyItemId] = useState(null);

  // ═══ Modal States ═══
  const [isOpenInputModal, setIsOpenInputModal] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [detailItem, setDetailItem] = useState({});
  const [isOpenEditItem, setIsOpenEditItem] = useState(false);
  const [, setIsEdit] = useState(false);
  const [, setIsSubmitItem] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);

  // Single Delete Modal
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [barangDelete, setBarangDelete] = useState(null);
  const [loadingDel, setLoadingDel] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [keterangan, setKeterangan] = useState('');

  // Bulk Modals
  const [openPrintBandrol, setOpenPrintBandrol] = useState(false);
  const [openTransferAntarToko, setOpenTransferAntarToko] = useState(false);
  const [openModalTransferToToko, setOpenModalTransferToToko] = useState(false);
  const [openPindahBanyakBarang, setOpenPindahBanyakBarang] = useState(false);
  const [openHapusBanyakBarang, setOpenHapusBanyakBarang] = useState(false);
  const [openPindahBanyakBaki, setOpenPindahBanyakBaki] = useState(false);

  const searchInputRef = useRef(null);
  const scanTimeoutRef = useRef(null);
  const previewRef = useRef(null);

  DinamicTitle('List Barang V2 || Komaladewi');

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

  // ═══ Selection Logic (Cross-page persistence) ═══
  const isCheckedAll = items.length > 0 && items.every((item) => selectedItems.some((si) => si.id === item.id));

  const totalBeratTerpilih = useMemo(() => {
    const sum = selectedItems.reduce((acc, curr) => acc + (parseFloat(curr.berat) || 0), 0);
    return parseFloat(sum.toFixed(3));
  }, [selectedItems]);

  const handleCheckboxChange = (event, item) => {
    if (event.target.checked) {
      if (selectedItems.some((si) => si.id === item.id)) {
        toast.info('Barang ini sudah dipilih sebelumnya.', { autoClose: 1500 });
        return;
      }
      const updated = [...selectedItems, item];
      setSelectedItems(updated);
      setSelectPindahItems(updated);
    } else {
      const updated = selectedItems.filter((si) => si.id !== item.id);
      setSelectedItems(updated);
      setSelectPindahItems(updated);
    }
  };

  const handleCheckAll = (event) => {
    if (event.target.checked) {
      const itemsToAdd = items.filter((item) => !selectedItems.some((si) => si.id === item.id));
      const updated = [...selectedItems, ...itemsToAdd];
      setSelectedItems(updated);
      setSelectPindahItems(updated);
    } else {
      const currentPageIds = new Set(items.map((it) => it.id));
      const remaining = selectedItems.filter((si) => !currentPageIds.has(si.id));
      setSelectedItems(remaining);
      setSelectPindahItems(remaining);
    }
  };

  const resetSelectPindahItems = () => {
    setSelectedItems([]);
    setSelectPindahItems([]);
    setShowSelectedPreview(false);
  };

  const syncSelectedItems = (updater) => {
    setSelectedItems(updater);
    setSelectPindahItems(updater);
  };

  // ═══ Fetch Data ═══
  const getItems = useCallback(async () => {
    setLoading(true);
    let queryBerat = '';
    if (berat) {
      queryBerat = `&berat=${encodeURIComponent(berat.trim())}`;
    }
    const isTokoParam = isOwnerAdminVerifikator ? '&is_toko=1' : '';
    const pageParam = `?page=${currentPage}`;
    const searchParam = search ? `?kode=${encodeURIComponent(search)}` : pageParam;
    const kategoriParam = selectedKategori ? `&kategori=${selectedKategori}` : '';
    const jenisParam = selectJenisKategori ? `&jenis_kategori=${selectJenisKategori}` : '';
    const statusParam = selectStatus ? `&status=${selectStatus}` : '';
    const cabangParam = selectCabang ? `&cabang=${selectCabang}` : '';
    const dateParam = startDate && endDate ? `&tgl_awal=${awal}&tgl_akhir=${akhir}` : '';
    const bakiParam = selectedBaki.length > 0 ? `&no_baki=${selectedBaki.join(',')}` : '';
    const karatParam = selectedKarat.length > 0 ? `&karat=${selectedKarat.join(',')}` : '';

    const endpoint = `/item${searchParam}${kategoriParam}${jenisParam}${statusParam}${cabangParam}${dateParam}${bakiParam}${karatParam}${queryBerat}${isTokoParam}`;

    try {
      const res = await http.get(endpoint, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      if (res.data?.data) {
        setItems(res.data.data.data || []);
        setTotalModal(res.data.total_modal || 0);
        setTotalModalFilter(res.data.total_modal_filter || 0);
        setJmlBarang(res.data.data.total || 0);
        setJmlBerat(res.data.total_berat_filter || 0);
        setLastPage(res.data.data.last_page || 1);
        setItemsPerPage(res.data.data.per_page || 10);
        setCurrentPage(res.data.data.current_page || 1);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/login');
      } else {
        console.error('Error fetching items V2:', err);
      }
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    search,
    selectedKategori,
    selectJenisKategori,
    selectStatus,
    selectCabang,
    startDate,
    endDate,
    awal,
    akhir,
    selectedBaki,
    selectedKarat,
    berat,
    isOwnerAdminVerifikator,
    navigate,
  ]);

  useEffect(() => {
    getItems();
  }, [getItems]);

  // Load fallback categories and branches if context not populated
  useEffect(() => {
    if (!cabangList || cabangList.length === 0) {
      http
        .get('/cabang', { headers: { Authorization: getAuthorizationHeader() } })
        .then((res) => setCabangLocal(res.data?.data || res.data || []))
        .catch((err) => console.error(err));
    }
    if (!kategoriList || kategoriList.length === 0) {
      http
        .get('/kategori', { headers: { Authorization: getAuthorizationHeader() } })
        .then((res) => setKategoriLocal(res.data || []))
        .catch((err) => console.error(err));
    }
  }, [cabangList, kategoriList]);

  // Sync page input
  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  // ═══ Barcode Scan Handler ═══
  const handleScanSearch = useCallback(
    async (kode) => {
      try {
        const res = await http.get(`/item?kode=${encodeURIComponent(kode)}`, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        const found = res.data?.data?.data;
        if (found && found.length > 0) {
          const item = found[0];
          const exists = selectedItems.some((si) => si.id === item.id);
          if (exists) {
            toast.info(`${item.kode_item} sudah dipilih sebelumnya`, { autoClose: 1500 });
          } else {
            setSelectedItems((prev) => [...prev, item]);
            setSelectPindahItems((prev) => [...prev, item]);
            toast.success(`Berhasil memilih: ${item.kode_item}`, { autoClose: 1500 });
          }
          setScanInput('');
          setSearch('');
          if (searchInputRef.current) searchInputRef.current.focus();
        } else {
          toast.warning(`Barang ${kode} tidak ditemukan`, { autoClose: 1500 });
        }
      } catch (err) {
        console.error('Scan error:', err);
      }
    },
    [selectedItems]
  );

  useEffect(() => {
    if (scanInput.length >= 10) {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = setTimeout(() => {
        handleScanSearch(scanInput);
      }, 300);
    }
    return () => {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
    };
  }, [scanInput, handleScanSearch]);

  // Auto-close preview panel outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (previewRef.current && !previewRef.current.contains(event.target)) {
        setShowSelectedPreview(false);
      }
    }
    if (showSelectedPreview) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showSelectedPreview]);

  // ═══ Pagination Controls ═══
  const jumpToPage = () => {
    const pageNum = parseInt(pageInput, 10);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= lastPage) {
      setCurrentPage(pageNum);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const nextPage = () => {
    if (currentPage < lastPage) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  // ═══ Copy Helper ═══
  const handleCopy = (id, kode) => {
    navigator.clipboard.writeText(kode);
    setCopyItemId(id);
    toast.success(`Kode ${kode} disalin`, { autoClose: 1200 });
    setTimeout(() => setCopyItemId(null), 2000);
  };

  // ═══ Number Format ═══
  const numberWithCommas = (x) => {
    if (x === null || x === undefined) return '0';
    return Number(x).toLocaleString('id-ID');
  };

  const checkBerat = (number) => {
    const val = parseFloat(number);
    if (isNaN(val)) return '0';
    return val % 1 === 0 ? val.toString() : val.toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
  };

  // ═══ Filter Helpers & Dropdown Listeners ═══
  const handleSelectKarat = (karat) => {
    const karatStr = String(karat);
    if (selectedKarat.includes(karatStr) || selectedKarat.includes(karat)) {
      setSelectedKarat(selectedKarat.filter((k) => String(k) !== karatStr));
    } else {
      setSelectedKarat([...selectedKarat, karatStr]);
    }
    setCurrentPage(1);
  };

  const handleSelectBaki = (baki) => {
    const bakiStr = String(baki);
    if (selectedBaki.includes(bakiStr) || selectedBaki.includes(baki)) {
      setSelectedBaki(selectedBaki.filter((b) => String(b) !== bakiStr));
    } else {
      setSelectedBaki([...selectedBaki, bakiStr]);
    }
    setCurrentPage(1);
  };

  // Auto-close Karat Dropdown
  useEffect(() => {
    function handleClickOutsideKarat(event) {
      if (karatDropdownRef.current && !karatDropdownRef.current.contains(event.target)) {
        setIsOpenKarat(false);
      }
    }
    if (isOpenKarat) {
      document.addEventListener('mousedown', handleClickOutsideKarat);
    } else {
      document.removeEventListener('mousedown', handleClickOutsideKarat);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideKarat);
    };
  }, [isOpenKarat]);

  // Auto-close Baki Dropdown
  useEffect(() => {
    function handleClickOutsideBaki(event) {
      if (bakiDropdownRef.current && !bakiDropdownRef.current.contains(event.target)) {
        setIsOpenBaki(false);
      }
    }
    if (isOpenBaki) {
      document.addEventListener('mousedown', handleClickOutsideBaki);
    } else {
      document.removeEventListener('mousedown', handleClickOutsideBaki);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideBaki);
    };
  }, [isOpenBaki]);

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  const handleSelect = (date) => {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    setCurrentPage(1);
  };

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
    setCurrentPage(1);
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
    setCurrentPage(1);
  };

  const filterBeratBarang = () => {
    setBerat(filterBerat);
    setCurrentPage(1);
  };

  const activeFilters = useMemo(() => {
    const list = [];
    if (startDate && endDate && awal && awal !== 'Invalid date') {
      list.push({
        id: 'date',
        label: awal === akhir ? awal : `${awal} - ${akhir}`,
        icon: '📅',
        onClear: () => {
          setStartDate(null);
          setEndDate(null);
          setCurrentPage(1);
        },
      });
    }
    if (selectCabang) {
      const namaCabang = etalaseOptions.find((cb) => String(cb.id) === String(selectCabang))?.nama_cabang || 'Etalase';
      list.push({
        id: 'cabang',
        label: namaCabang,
        icon: '🏪',
        onClear: () => {
          setSelectCabang('');
          setCurrentPage(1);
        },
      });
    }
    if (selectedKategori) {
      const namaKategori = kategori.find((kt) => String(kt.id) === String(selectedKategori))?.nama_kategori || 'Kategori';
      list.push({
        id: 'kategori',
        label: namaKategori,
        icon: '🏷️',
        onClear: () => {
          setSelectedKategori('');
          setSelectJenisKategori('');
          setCurrentPage(1);
        },
      });
    }
    if (selectJenisKategori && selectedKategori) {
      const namaJenis = kategori
        .find((kt) => String(kt.id) === String(selectedKategori))
        ?.jenis_kategori?.find((jk) => String(jk.id) === String(selectJenisKategori))?.nama_jenis || 'Jenis';
      list.push({
        id: 'jenis',
        label: namaJenis,
        icon: '✨',
        onClear: () => {
          setSelectJenisKategori('');
          setCurrentPage(1);
        },
      });
    }
    if (selectedBaki && selectedBaki.length > 0) {
      list.push({
        id: 'baki',
        label: `Baki: ${selectedBaki.join(', ')}`,
        icon: '📥',
        onClear: () => {
          setSelectedBaki([]);
          setCurrentPage(1);
        },
      });
    }
    if (selectedKarat && selectedKarat.length > 0) {
      list.push({
        id: 'karat',
        label: `Karat: ${selectedKarat.map((k) => `${k}k`).join(', ')}`,
        icon: '💎',
        onClear: () => {
          setSelectedKarat([]);
          setCurrentPage(1);
        },
      });
    }
    if (berat || filterBerat) {
      list.push({
        id: 'berat',
        label: `Berat: ${berat || filterBerat} gr`,
        icon: '⚖️',
        onClear: () => {
          setFilterBerat('');
          setBerat('');
          setCurrentPage(1);
        },
      });
    }
    return list;
  }, [startDate, endDate, awal, akhir, selectCabang, etalaseOptions, selectedKategori, selectJenisKategori, kategori, selectedBaki, selectedKarat, berat, filterBerat]);

  const activeFilterCount = activeFilters.length;

  const handleResetFilters = () => {
    setSelectedKategori('');
    setSelectJenisKategori('');
    setSelectedBaki([]);
    setSelectedKarat([]);
    setFilterBerat('');
    setBerat('');
    setSearch('');
    setScanInput('');
    setStartDate(null);
    setEndDate(null);
    setSelectStatus('');
    setSelectCabang('');
    setCurrentPage(1);
  };

  // ═══ Single Action Handlers ═══
  const showDetailItem = (id) => {
    const item = items.find((it) => it.id === id);
    if (item) {
      setDetailItem(item);
      setOpenDetail(true);
    } else {
      toast.error('Data item tidak ditemukan');
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getItemEdit = async (id) => {
    setOpenLoading(true);
    try {
      const res = await http.get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setDetailItem(res.data.data);
      setIsOpenEditItem(true);
    } catch (err) {
      toast.error('Gagal mengambil data untuk diedit');
    } finally {
      setOpenLoading(false);
    }
  };

  const getIdDelete = async (id) => {
    setLoadingDel(true);
    try {
      const res = await http.get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setDeleteId(res.data.data.id);
      setBarangDelete(res.data.data);
      setIsOpenModalDelete(true);
    } catch (err) {
      toast.error('Gagal memuat konfirmasi hapus');
    } finally {
      setLoadingDel(false);
    }
  };

  const deleteBarang = async (e) => {
    if (e) e.preventDefault();
    if (!keterangan.trim()) {
      toast.error('Alasan penghapusan harus diisi', { autoClose: 1500 });
      return;
    }
    setIsDelete(true);
    const userRole = localStorage.getItem('role');
    const isOperatorToko = userRole === 'operator' || userRole === 'operator_toko' || userRole === 'kepala_toko';

    try {
      if (isOperatorToko) {
        await http.post(
          '/item-deletions/ajukan',
          {
            items: [deleteId],
            alasan: keterangan,
          },
          { headers: { Authorization: getAuthorizationHeader() } }
        );
        toast.success('Pengajuan hapus barang berhasil dikirim ke Admin/Owner');
      } else {
        const res = await http.post(
          `item/hapus`,
          { item_id: deleteId, keterangan },
          { headers: { Authorization: getAuthorizationHeader() } }
        );
        toast.success(res.data?.message || 'Data berhasil dihapus');
      }
      setIsOpenModalDelete(false);
      setKeterangan('');
      getItems();
      resetSelectPindahItems();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gagal memproses penghapusan barang');
    } finally {
      setIsDelete(false);
    }
  };

  return (
    <Layouts title="List Barang V2">
      {/* ═══ Modals ═══ */}
      <ConfirmationDeleteItem
        reloadDate={getItems}
        isDelete={isDelete}
        deleteBarang={deleteBarang}
        setKeterangan={setKeterangan}
        barangDelete={barangDelete}
        isOpenModalDelete={isOpenModalDelete}
        closeModaDelete={() => setIsOpenModalDelete(false)}
        isRequest={user === 'operator' || user === 'operator_toko' || user === 'kepala_toko'}
      />

      <InputBarang
        setIsSubmitItem={() => setIsSubmitItem(true)}
        closeModal={() => setIsOpenInputModal(false)}
        isOpen={isOpenInputModal}
        kategori={kategori}
      />

      {isOpenEditItem && (
        <EditItem
          setIsEdit={setIsEdit}
          kategori={kategori}
          cabang={cabang}
          detailItem={detailItem || {}}
          isOpenEditItem={isOpenEditItem}
          closeModalEditItem={() => setIsOpenEditItem(false)}
        />
      )}

      {openDetail && (
        <DetailItem
          checkBerat={checkBerat}
          detailItem={detailItem || {}}
          closeModalDetail={() => setOpenDetail(false)}
          openDetail={openDetail}
        />
      )}

      <PrintBandrol
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        openPrintBandrol={openPrintBandrol}
        closeModalPrintBandrol={() => setOpenPrintBandrol(false)}
      />

      <ModalTransferAntarToko
        isOpen={openTransferAntarToko}
        onClose={() => setOpenTransferAntarToko(false)}
        selectedItems={selectedItems}
        setSelectedItems={syncSelectedItems}
        onSuccess={() => {
          getItems();
          resetSelectPindahItems();
        }}
      />

      <TransferBarangToCabang
        openPindahBarangBanyak={openModalTransferToToko}
        setOpenPindahBanyakBarang={setOpenModalTransferToToko}
        reloadDate={getItems}
        closeModalBanyakBarang={() => setOpenModalTransferToToko(false)}
        selectedItems={selectPindahItems}
        refreshPage={getItems}
        setSelectedItems={setSelectPindahItems}
        resetSelectPindahItems={resetSelectPindahItems}
      />

      <TransferBanyakBarang
        cabang={cabang}
        reloadDate={getItems}
        selectedItems={selectPindahItems}
        setSelectedItems={setSelectPindahItems}
        openPindahBarangBanyak={openPindahBanyakBarang}
        setOpenPindahBanyakBarang={setOpenPindahBanyakBarang}
        closeModalBanyakBarang={() => setOpenPindahBanyakBarang(false)}
        refreshPage={getItems}
        resetSelectPindahItems={resetSelectPindahItems}
      />

      <HapusBanyakBarang
        cabang={cabang}
        reloadDate={getItems}
        selectedItems={selectedItems}
        setSelectedItems={syncSelectedItems}
        openHapusBarangBanyak={openHapusBanyakBarang}
        setOpenHapusBanyakBarang={setOpenHapusBanyakBarang}
        closeModalBanyakBarang={() => setOpenHapusBanyakBarang(false)}
        refreshPage={getItems}
        resetSelectPindahItems={resetSelectPindahItems}
      />

      <PindahBakiBanyak
        reloadDate={getItems}
        selectedItems={selectedItems}
        setSelectedItems={syncSelectedItems}
        openPindahBanyakBaki={openPindahBanyakBaki}
        setOpenPindahBanyakBaki={setOpenPindahBanyakBaki}
        closeModalBanyakBarang={() => setOpenPindahBanyakBaki(false)}
        refreshPage={getItems}
        resetSelectPindahItems={resetSelectPindahItems}
      />

      {(openLoading || loadingDel) && <LoadingIndicator />}

      {/* ═══ Main Page Container ═══ */}
      <div className="flex flex-col min-h-[calc(100vh-65px)] pb-28">
        {/* ═══ Mobile/Desktop Header Strip ═══ */}
        <div className="sticky top-0 z-30 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-b border-amber-100 dark:border-slate-800 px-3 sm:px-6 py-2.5 sm:py-3 transition-colors shadow-xs">
          <div className="flex flex-col gap-2.5">
            {/* Row 1: Title, View Switcher & Action Controls */}
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                <div className="p-2 rounded-xl bg-gradient-to-tr from-amber-500 to-amber-400 text-white shadow-sm flex-shrink-0">
                  <IconBuildingStore size={18} />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <h2 className="text-base sm:text-lg font-bold text-slate-800 dark:text-slate-100 truncate">
                      List Barang
                    </h2>
                    {/* <span className="px-2 py-0.5 text-[10px] font-extrabold uppercase rounded-md bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-300">
                      Mobile
                    </span> */}
                  </div>
                  {/* <p className="text-[11px] text-slate-400 dark:text-slate-500 truncate">
                    Tampilan modern, responsif & cepat untuk smartphone
                  </p> */}
                </div>
              </div>

              {/* View Switcher & Reload Buttons */}
              <div className="flex items-center gap-1.5 flex-shrink-0">
                {/* View Switcher (Card vs Table) */}
                <div className="inline-flex rounded-xl border border-slate-200 dark:border-slate-700 p-0.5 bg-slate-100 dark:bg-slate-800">
                  <button
                    type="button"
                    onClick={() => setViewMode('cards')}
                    className={`px-2.5 py-1 text-xs font-semibold rounded-lg flex items-center gap-1 transition-all cursor-pointer ${
                      viewMode === 'cards'
                        ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-xs'
                        : 'text-slate-600 dark:text-slate-400 hover:text-slate-900'
                    }`}
                    title="Tampilan Kartu (Mobile)"
                  >
                    <IconLayoutGrid size={15} />
                    <span className="hidden sm:inline">Kartu</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setViewMode('table')}
                    className={`px-2.5 py-1 text-xs font-semibold rounded-lg flex items-center gap-1 transition-all cursor-pointer ${
                      viewMode === 'table'
                        ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-xs'
                        : 'text-slate-600 dark:text-slate-400 hover:text-slate-900'
                    }`}
                    title="Tampilan Tabel"
                  >
                    <IconTable size={15} />
                    <span className="hidden sm:inline">Tabel</span>
                  </button>
                </div>

                {/* Reload Button */}
                <button
                  type="button"
                  onClick={getItems}
                  disabled={loading}
                  className="p-2 text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl hover:border-amber-300 transition-colors shadow-xs cursor-pointer"
                  title="Muat Ulang Data"
                >
                  <IconReload size={16} className={loading ? 'animate-spin' : ''} />
                </button>

                {/* Tambah Barang (for allowed roles) */}
                {user !== 'admin' && user !== 'operator' && (
                  <button
                    type="button"
                    onClick={() => setIsOpenInputModal(true)}
                    className="p-2 sm:px-3 sm:py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-xl text-xs font-bold flex items-center gap-1 shadow-sm transition-all cursor-pointer"
                    title="Tambah Barang Baru"
                  >
                    <IconPlus size={16} />
                    <span className="hidden sm:inline">Tambah</span>
                  </button>
                )}
              </div>
            </div>

            {/* Row 2: KPI Metrics Strip (Touch friendly pills) */}
            <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-none text-xs">
              {/* Total Barang */}
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-amber-50/80 dark:bg-amber-950/30 border border-amber-200/60 dark:border-amber-900/40 text-amber-900 dark:text-amber-200 flex-shrink-0 font-medium">
                <span className="text-amber-600 dark:text-amber-400 font-bold">Total:</span>
                <span className="font-extrabold">{numberWithCommas(jmlBarang)}</span>
                <span className="text-[11px] text-amber-700/70 dark:text-amber-400">item</span>
              </div>

              {/* Total Berat */}
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 flex-shrink-0 font-medium">
                {/* <IconScale size={14} className="text-amber-500" /> */}
                <span className="font-extrabold">{jmlBerat}</span>
                <span className="text-[11px] text-slate-400">gram</span>
              </div>

              {/* Total Modal (Khusus Owner / Admin / Verifikator) */}
              {/* {isOwnerAdminVerifikator && ( */}
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-emerald-50/80 dark:bg-emerald-950/30 border border-emerald-200/60 dark:border-emerald-900/40 text-emerald-900 dark:text-emerald-200 flex-shrink-0 font-medium">
                  <span className="text-emerald-600 dark:text-emerald-400 font-bold">Modal:</span>
                  <span className="font-extrabold">
                    Rp {numberWithCommas(totalModalFilter)}
                  </span>
                </div>
              {/* )} */}

              {/* Barang Terpilih Counter */}
              {selectedItems.length > 0 && (
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-amber-500 text-white font-bold flex-shrink-0 shadow-xs animate-fade-in">
                  <IconCheck size={14} />
                  <span>{selectedItems.length} terpilih</span>
                  <span className="text-amber-100 text-[11px]">({totalBeratTerpilih} gr)</span>
                </div>
              )}
            </div>

            {/* Row 3: Search Bar & Filter Drawer Button */}
            <div className="flex items-center gap-2">
              {/* Search Bar */}
              <div className="relative flex-1">
                <IconSearch
                  size={17}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 pointer-events-none"
                />
                <input
                  ref={searchInputRef}
                  type="text"
                  value={scanInput}
                  onChange={(e) => {
                    setScanInput(e.target.value);
                    if (e.target.value.length < 10) {
                      setSearch(e.target.value);
                    }
                  }}
                  placeholder="Cari kode barang atau scan barcode..."
                  className="w-full pl-9 pr-8 py-2 text-xs sm:text-sm bg-slate-100 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 rounded-xl focus:border-amber-400 focus:bg-white dark:focus:bg-slate-900 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 outline-none text-slate-800 dark:text-slate-100 placeholder:text-slate-400 transition-all"
                />
                {scanInput && (
                  <button
                    type="button"
                    onClick={() => {
                      setScanInput('');
                      setSearch('');
                      if (searchInputRef.current) searchInputRef.current.focus();
                    }}
                    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-rose-500 p-0.5"
                  >
                    <IconX size={15} />
                  </button>
                )}
              </div>

              {/* Filter Toggle Button */}
              <button
                type="button"
                onClick={() => setIsFilterOpen(true)}
                className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-semibold border transition-all shrink-0 cursor-pointer shadow-xs ${
                  isFilterOpen || activeFilterCount > 0
                    ? 'bg-amber-500 border-amber-600 text-white shadow-amber-500/20'
                    : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:border-amber-300 dark:hover:border-amber-500'
                }`}
                title="Buka Filter"
              >
                <IconAdjustmentsHorizontal size={16} />
                <span className="hidden sm:inline">Filter</span>
                {activeFilterCount > 0 && (
                  <span
                    className={`px-1.5 py-0.2 text-[10px] font-bold rounded-full leading-tight ${
                      isFilterOpen || activeFilterCount > 0
                        ? 'bg-white text-amber-700'
                        : 'bg-amber-500 text-white'
                    }`}
                  >
                    {activeFilterCount}
                  </span>
                )}
              </button>
            </div>

            {/* Active Filter Chips (Pills horizontal scroll) */}
            {activeFilterCount > 0 && (
              <div className="flex items-center gap-1.5 overflow-x-auto py-1 w-full max-w-full no-scrollbar text-xs">
                <span className="text-[11px] font-semibold text-slate-400 dark:text-slate-500 shrink-0 uppercase tracking-wider">
                  Filter:
                </span>
                {activeFilters.map((flt) => (
                  <div
                    key={flt.id}
                    className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 font-medium whitespace-nowrap shadow-2xs shrink-0"
                  >
                    <span className="text-xs">{flt.icon}</span>
                    <span className="max-w-[150px] sm:max-w-[200px] truncate">{flt.label}</span>
                    <button
                      type="button"
                      onClick={flt.onClear}
                      className="p-0.5 hover:bg-amber-200/60 dark:hover:bg-amber-800/60 rounded-full transition-colors ml-0.5 cursor-pointer text-amber-600 dark:text-amber-400"
                      title={`Hapus filter ${flt.label}`}
                    >
                      <IconX size={12} />
                    </button>
                  </div>
                ))}

                <button
                  type="button"
                  onClick={handleResetFilters}
                  className="text-[11px] font-bold text-rose-600 dark:text-rose-400 hover:underline px-2 py-0.5 rounded shrink-0 cursor-pointer whitespace-nowrap"
                >
                  Reset Semua
                </button>
              </div>
            )}

            {/* ═══ Filter Slide-over Drawer (Muncul dari Kanan Layar) ═══ */}
            <Transition appear show={isFilterOpen} as={Fragment}>
              <Dialog
                as="div"
                className="relative z-[99999]"
                onClose={() => setIsFilterOpen(false)}
              >
                {/* Backdrop Overlay Tipis & Tanpa Blur (Data di samping tetap tajam dan terbaca jelas) */}
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-slate-900/15 dark:bg-black/30 pointer-events-auto" />
                </Transition.Child>

                {/* Drawer Container */}
                <div className="fixed inset-0 overflow-hidden pointer-events-none">
                  <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
                    <Transition.Child
                      as={Fragment}
                      enter="transform transition ease-in-out duration-300 sm:duration-400"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-300 sm:duration-400"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto w-screen max-w-[340px] sm:max-w-[420px] transform bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-800 text-left align-middle transition-all flex flex-col h-screen max-h-screen">
                        {/* Drawer Header */}
                        <div className="px-4 py-3.5 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between shrink-0 sticky top-0 z-20">
                          <div className="flex items-center gap-2">
                            <div className="p-1.5 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400">
                              <IconAdjustmentsHorizontal size={18} />
                            </div>
                            <div>
                              <Dialog.Title as="h2" className="text-sm font-bold text-slate-800 dark:text-slate-100">
                                Filter Barang
                              </Dialog.Title>
                              <p className="text-[11px] text-slate-500 dark:text-slate-400">
                                {activeFilterCount > 0
                                  ? `${activeFilterCount} kriteria aktif`
                                  : 'Filter pencarian barang'}
                              </p>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => setIsFilterOpen(false)}
                            className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                          >
                            <IconX size={16} />
                          </button>
                        </div>

                        {/* Drawer Body */}
                        <div className="p-4 flex-1 bg-slate-50/50 dark:bg-slate-900/50 overflow-y-auto space-y-3.5">
                          {/* 1. Filter Tanggal */}
                          <div className="space-y-1.5">
                            <div className="dropdown dropdown-bottom w-full">
                              <div
                                tabIndex={0}
                                className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 flex items-center justify-between gap-1.5 shadow-xs"
                                title="Filter Tanggal"
                              >
                                <div className="flex items-center gap-2 truncate">
                                  <IconCalendarTime size={16} className="text-amber-500 shrink-0" />
                                  <span className="truncate">
                                    {startDate && endDate && awal && awal !== 'Invalid date'
                                      ? awal === akhir
                                        ? awal
                                        : `${awal} - ${akhir}`
                                      : 'Pilih Rentang Tanggal'}
                                  </span>
                                </div>
                                <IconChevronDown size={14} className="text-slate-400 shrink-0" />
                              </div>
                              <div
                                tabIndex={0}
                                className="dropdown-content menu p-2 shadow-2xl bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 z-[9999] mt-1 left-0 max-w-[92vw] overflow-x-auto"
                              >
                                <DateRange ranges={[selectionRange]} onChange={handleSelect} />
                                {startDate && (
                                  <div className="p-2 border-t border-slate-200 dark:border-slate-700 flex justify-end">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setStartDate(null);
                                        setEndDate(null);
                                        setCurrentPage(1);
                                      }}
                                      className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                                    >
                                      Reset Tanggal
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* 2. Filter Etalase (Toko) - Khusus Owner / Admin / Verifikator */}
                          {isOwnerAdminVerifikator && (
                            <div className="space-y-1.5">
                              <select
                                value={selectCabang}
                                onChange={(e) => {
                                  setSelectCabang(e.target.value);
                                  setCurrentPage(1);
                                }}
                                className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                              >
                                <option value="">Semua Etalase (Toko)</option>
                                {etalaseOptions.map((cb) => (
                                  <option key={cb.id} value={cb.id}>
                                    {cb.nama_cabang}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 3. Kategori */}
                          <div className="space-y-1.5">
                            <select
                              value={selectedKategori}
                              onChange={handleKategoriChange}
                              className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs"
                            >
                              <option value="">Semua Kategori</option>
                              {kategori.map((kt) => (
                                <option key={kt.id} value={kt.id}>
                                  {kt.nama_kategori}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* 4. Jenis Kategori */}
                          <div className="space-y-1.5">
                            <select
                              onChange={handleJenisKategoriChange}
                              value={selectJenisKategori}
                              disabled={!selectedKategori}
                              className={`w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 outline-none shadow-xs ${
                                !selectedKategori
                                  ? 'opacity-50 cursor-not-allowed'
                                  : 'cursor-pointer hover:border-amber-300 dark:hover:border-amber-500'
                              }`}
                            >
                              <option value="">Semua Jenis</option>
                              {selectedKategori &&
                                kategori
                                  .find((kt) => kt.id === parseInt(selectedKategori, 10))
                                  ?.jenis_kategori?.map((jk) => (
                                    <option key={jk.id} value={jk.id}>
                                      {jk.nama_jenis}
                                    </option>
                                  ))}
                            </select>
                          </div>

                          {/* 5. Baki Multi-Select Grid */}
                          <div className="space-y-1.5">
                            {selectedBaki.length > 0 && (
                              <div className="flex items-center justify-end">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedBaki([]);
                                    setCurrentPage(1);
                                  }}
                                  className="text-xs text-rose-500 hover:text-rose-600 font-bold hover:underline cursor-pointer"
                                >
                                  Reset Baki ({selectedBaki.length} dipilih)
                                </button>
                              </div>
                            )}
                            <div className="p-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl max-h-44 overflow-y-auto">
                              <div className="grid grid-cols-3 gap-1.5">
                                {bakiOptions.map((ftb) => {
                                  const ftbStr = String(ftb);
                                  const isChecked = selectedBaki.includes(ftbStr) || selectedBaki.includes(ftb);
                                  return (
                                    <label
                                      key={ftb}
                                      className={`flex items-center gap-1.5 p-1.5 rounded-lg border text-xs cursor-pointer transition-all ${
                                        isChecked
                                          ? 'bg-amber-50 dark:bg-amber-950/40 border-amber-400 text-amber-800 dark:text-amber-300 font-bold shadow-2xs'
                                          : 'border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-slate-700 dark:text-slate-300'
                                      }`}
                                    >
                                      <input
                                        type="checkbox"
                                        className="checkbox checkbox-xs checkbox-warning rounded"
                                        checked={isChecked}
                                        onChange={() => handleSelectBaki(ftb)}
                                      />
                                      <span className="truncate">{ftb}</span>
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          </div>

                          {/* 6. Karat Multi-Select Grid */}
                          <div className="space-y-1.5">
                            {selectedKarat.length > 0 && (
                              <div className="flex items-center justify-end">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedKarat([]);
                                    setCurrentPage(1);
                                  }}
                                  className="text-xs text-rose-500 hover:text-rose-600 font-bold hover:underline cursor-pointer"
                                >
                                  Reset Karat ({selectedKarat.length} dipilih)
                                </button>
                              </div>
                            )}
                            <div className="p-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl">
                              <div className="grid grid-cols-3 gap-1.5 max-h-36 overflow-y-auto">
                                {karatOptions.map((kto) => {
                                  const ktoStr = String(kto);
                                  const isChecked = selectedKarat.includes(ktoStr) || selectedKarat.includes(kto);
                                  return (
                                    <label
                                      key={kto}
                                      className={`flex items-center gap-1.5 p-1.5 rounded-lg border text-xs cursor-pointer transition-all ${
                                        isChecked
                                          ? 'bg-amber-50 dark:bg-amber-950/40 border-amber-400 text-amber-800 dark:text-amber-300 font-bold shadow-2xs'
                                          : 'border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-slate-700 dark:text-slate-300'
                                      }`}
                                    >
                                      <input
                                        type="checkbox"
                                        className="checkbox checkbox-xs checkbox-warning rounded"
                                        checked={isChecked}
                                        onChange={() => handleSelectKarat(kto)}
                                      />
                                      <span>{kto}k</span>
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          </div>

                          {/* 7. Filter Berat */}
                          <div className="space-y-1.5">
                            <div className="relative">
                              <input
                                value={filterBerat}
                                onChange={(e) => setFilterBerat(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    filterBeratBarang();
                                  }
                                }}
                                placeholder="Berat barang (contoh: 10, ~10)"
                                className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl pl-3 pr-10 text-xs sm:text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none shadow-xs"
                              />
                              <button
                                type="button"
                                onClick={filterBeratBarang}
                                className="absolute right-1 top-1/2 -translate-y-1/2 p-2 text-amber-600 hover:text-amber-700 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer"
                                title="Terapkan Berat"
                              >
                                <IconSearch size={16} />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Drawer Footer */}
                        <div className="px-4 py-3 border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between gap-2 shrink-0 sticky bottom-0 z-20">
                          <div className="text-xs text-slate-500 dark:text-slate-400">
                            {activeFilterCount > 0 ? (
                              <span className="font-semibold text-amber-600 dark:text-amber-400">
                                {activeFilterCount} aktif
                              </span>
                            ) : (
                              'Filter'
                            )}
                          </div>
                          <div className="flex items-center gap-1.5">
                            {activeFilterCount > 0 && (
                              <button
                                type="button"
                                onClick={handleResetFilters}
                                className="px-2.5 py-1.5 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/30 rounded-xl transition-colors cursor-pointer"
                              >
                                Reset
                              </button>
                            )}
                            <button
                              type="button"
                              onClick={() => setIsFilterOpen(false)}
                              className="px-3.5 py-1.5 text-xs font-bold bg-amber-500 hover:bg-amber-600 active:scale-95 text-white rounded-xl shadow-sm transition-all cursor-pointer"
                            >
                              Tutup
                            </button>
                          </div>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
          </div>
        </div>

        {/* ═══ Content Area (Cards or Table) ═══ */}
        <div className="px-3 sm:px-6 py-4 flex-1">
          {loading ? (
            <div className="py-24 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm flex flex-col items-center justify-center gap-3">
              <span className="loading loading-spinner loading-lg text-amber-500"></span>
              <p className="text-slate-400 text-xs font-semibold animate-pulse">Memuat data barang...</p>
            </div>
          ) : !items || items.length === 0 ? (
            <div className="py-20 text-center bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 p-6 flex flex-col items-center justify-center gap-3 shadow-sm">
              <div className="w-14 h-14 rounded-full bg-amber-50 dark:bg-amber-950/30 text-amber-500 flex items-center justify-center border border-amber-200/60 dark:border-amber-900/40">
                <IconInbox size={28} />
              </div>
              <div>
                <h3 className="text-base font-bold text-slate-800 dark:text-slate-200">Tidak Ada Data Barang</h3>
                <p className="text-xs text-slate-400 dark:text-slate-500 max-w-sm mt-1">
                  Tidak ditemukan barang yang sesuai dengan filter saat ini. Coba reset filter atau ubah kata kunci pencarian.
                </p>
              </div>
              {activeFilterCount > 0 && (
                <button
                  type="button"
                  onClick={handleResetFilters}
                  className="mt-2 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-xs font-bold rounded-xl shadow-xs transition-all cursor-pointer"
                >
                  Reset Semua Filter
                </button>
              )}
            </div>
          ) : viewMode === 'cards' ? (
            /* ═══════════════════════════════════════════════════════════ */
            /* CARD FEED VIEW (Mobile & Responsive Grid)                   */
            /* ═══════════════════════════════════════════════════════════ */
            <div className="space-y-3 sm:space-y-4">
              {/* Select All Toggle Bar on Mobile */}
              <div className="flex items-center justify-between px-3 py-2 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-xs">
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={isCheckedAll}
                    onChange={handleCheckAll}
                    className="checkbox checkbox-warning w-5 h-5 rounded-md border-slate-300 dark:border-slate-600"
                  />
                  <span className="text-xs font-bold text-slate-700 dark:text-slate-200">
                    Pilih Semua ({items.length} di hal. ini)
                  </span>
                </label>
                <span className="text-[11px] text-slate-400 font-medium">
                  Total Berat Hal: {parseFloat(items.reduce((acc, curr) => acc + (Number(curr.berat) || 0), 0).toFixed(3))} gr
                </span>
              </div>

              {/* Cards Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4">
                {items.map((item, idx) => {
                  const isSelected = selectedItems.some((si) => si.id === item.id);
                  const imageUrl = resolveItemImageUrl(item);

                  return (
                    <div
                      key={item.id || idx}
                      onClick={() => showDetailItem(item.id)}
                      className={`bg-white dark:bg-slate-900 rounded-2xl p-3 sm:p-3.5 border transition-all duration-200 shadow-xs hover:shadow-md cursor-pointer relative group ${
                        isSelected
                          ? 'border-amber-400 ring-2 ring-amber-400/20 bg-amber-50/20 dark:bg-amber-950/10'
                          : 'border-slate-200/80 dark:border-slate-800 hover:border-slate-300'
                      }`}
                    >
                      {/* Top Header Row: Checkbox, Kode, Copy, and Store / Non-ready indicator */}
                      <div className="flex items-center justify-between gap-2 mb-2">
                        <div className="flex items-center gap-2 min-w-0">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleCheckboxChange(e, item);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            className="checkbox checkbox-warning w-4 h-4 rounded-md border-slate-300 dark:border-slate-600 cursor-pointer flex-shrink-0"
                          />
                          <span
                            className={`font-mono font-bold text-xs sm:text-sm tracking-tight truncate ${
                              item.is_ready === true || item.status === 'ready'
                                ? 'text-slate-800 dark:text-slate-100'
                                : 'line-through text-slate-400'
                            }`}
                          >
                            {item.kode_item}
                          </span>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCopy(item.id, item.kode_item);
                            }}
                            className="text-slate-400 hover:text-amber-500 p-0.5 rounded transition-colors flex-shrink-0"
                            title="Salin Kode"
                          >
                            {copyItemId === item.id ? (
                              <IconCheck size={13} className="text-emerald-500" />
                            ) : (
                              <IconCopy size={13} />
                            )}
                          </button>
                        </div>

                        {/* Right header: Store name (or warning if not ready) - Ready status removed */}
                        <div className="flex items-center gap-1.5 flex-shrink-0">
                          {item.is_ready === false || (item.status && item.status !== 'ready') ? (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold text-rose-600 bg-rose-50 dark:bg-rose-950/50 px-2 py-0.5 rounded-full border border-rose-200 dark:border-rose-900/40">
                              <span className="w-1.5 h-1.5 rounded-full bg-rose-500"></span>
                              <span>{item.status || 'Tidak Ready'}</span>
                            </span>
                          ) : item.cabang?.nama_cabang ? (
                            <span className="text-[11px] text-slate-500 dark:text-slate-400 font-medium flex items-center gap-1 bg-slate-100 dark:bg-slate-800/80 px-2 py-0.5 rounded-full max-w-[140px] truncate">
                              <span className="truncate">{item.cabang.nama_cabang}</span>
                            </span>
                          ) : null}
                        </div>
                      </div>

                      {/* Main Content: Thumbnail + Info */}
                      <div className="flex items-center gap-3">
                        {/* Thumbnail */}
                        <div
                          onClick={(e) => e.stopPropagation()}
                          className="w-16 h-16 sm:w-18 sm:h-18 rounded-xl bg-slate-100 dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 flex-shrink-0 overflow-hidden flex items-center justify-center relative"
                        >
                          {imageUrl ? (
                            <PhotoView src={imageUrl}>
                              <img
                                src={imageUrl}
                                alt={item.kode_item}
                                className="w-full h-full object-cover cursor-zoom-in hover:scale-105 transition-transform duration-300"
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            </PhotoView>
                          ) : (
                            <IconBarcode size={22} className="text-slate-300 dark:text-slate-600" />
                          )}
                        </div>

                        {/* Info & Clean Specs */}
                        <div className="flex-1 min-w-0 space-y-1.5">
                          <h4 className="font-bold text-xs sm:text-sm text-slate-800 dark:text-slate-200 truncate">
                            {item.jenis_kategori?.nama_jenis || item.nama_item || 'Perhiasan Emas'}
                          </h4>

                          {/* Clean Specs with rhythmic bullet separators */}
                          <div className="flex items-center gap-1.5 flex-wrap text-[11px] text-slate-500 dark:text-slate-400">
                            <span className="font-extrabold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/50 px-2 py-0.5 rounded-md border border-amber-200/80 dark:border-amber-800/50">
                              {item.berat} gr
                            </span>
                            <span className="text-slate-300 dark:text-slate-600">•</span>
                            <span className="font-semibold text-slate-700 dark:text-slate-300">
                              {item.karat}k
                            </span>
                            {item.nomor_rak && (
                              <>
                                <span className="text-slate-300 dark:text-slate-600">•</span>
                                <span>Baki {item.nomor_rak}</span>
                              </>
                            )}
                            {item.ukuran && item.ukuran !== '-' && (
                              <>
                                <span className="text-slate-300 dark:text-slate-600">•</span>
                                <span>Ukuran {item.ukuran}</span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Bottom Row: Modal/Price & Action Buttons */}
                      <div className="flex items-center justify-between gap-2 pt-2.5 mt-2.5 border-t border-slate-100 dark:border-slate-800 text-xs">
                        <div className="flex items-baseline gap-1.5">
                          <span className="text-[10px] uppercase font-bold text-slate-400 dark:text-slate-500 tracking-wider">
                           Modal:
                          </span>
                          <span className="font-bold text-xs sm:text-sm text-slate-800 dark:text-slate-100 font-mono tracking-tight">
                            Rp {numberWithCommas(item.harga_modal || 0)}
                          </span>
                        </div>

                        {/* Action Buttons */}
                        <div onClick={(e) => e.stopPropagation()} className="flex items-center gap-1 flex-shrink-0">
                          {['admin', 'owner', 'operator', 'operator_toko', 'verifikator', 'kepala_toko'].includes(user) && (
                            <button
                              type="button"
                              onClick={() => getIdDelete(item.id)}
                              className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/40 transition-colors cursor-pointer"
                              title="Hapus Item"
                            >
                              <IconTrash size={16} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            /* ═══════════════════════════════════════════════════════════ */
            /* TABLE VIEW (Desktop / Dense Mode)                           */
            /* ═══════════════════════════════════════════════════════════ */
            <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 overflow-hidden shadow-xs">
              <div className="overflow-x-auto custom-scrollbar">
                <table className="w-full text-left text-xs text-slate-700 dark:text-slate-300">
                  <thead className="bg-amber-50/60 dark:bg-slate-800/80 text-slate-700 dark:text-slate-200 uppercase font-bold text-[11px] border-b border-amber-200/60 dark:border-slate-700">
                    <tr>
                      <th className="px-2 py-2 w-10 text-center">#</th>
                      <th className="px-2 py-2">Foto</th>
                      <th className="px-2 py-2">Kode Baang</th>
                      <th className="px-2 py-2">Nama Barang</th>
                      <th className="px-2 py-2">Baki</th>
                      <th className="px-2 py-2">Berat | Karat</th>
                      <th className="px-2 py-2">Ukuran</th>
                      <th className="px-2 py-2">Lokasi</th>
                      {isOwnerAdminVerifikator && <th className="px-2 py-2">Modal</th>}
                      <th className="px-2 py-2 text-center">Aksi</th>
                      <th className="px-2 py-2 text-center w-12">
                        <input
                          type="checkbox"
                          checked={isCheckedAll}
                          onChange={handleCheckAll}
                          className="checkbox checkbox-warning w-4 h-4 rounded-md border-amber-400 dark:border-slate-500 cursor-pointer"
                          title="Pilih Semua"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                    {items.map((item, index) => {
                      const isSelected = selectedItems.some((si) => si.id === item.id);
                      const imageUrl = resolveItemImageUrl(item);
                      const startIndex = (currentPage - 1) * itemsPerPage;

                      return (
                        <tr
                          key={item.id || index}
                          onClick={() => showDetailItem(item.id)}
                          className={`hover:bg-amber-50/40 dark:hover:bg-slate-800/50 transition-colors cursor-pointer ${
                            isSelected ? 'bg-amber-50/30 dark:bg-amber-950/20' : ''
                          }`}
                        >
                          <td className="px-2 py-2 text-center text-slate-400">{startIndex + index + 1}</td>
                          <td className="px-2 py-2" onClick={(e) => e.stopPropagation()}>
                            <div className="w-10 h-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center overflow-hidden">
                              {imageUrl ? (
                                <PhotoView src={imageUrl}>
                                  <img src={imageUrl} alt="" className="w-full h-full object-cover cursor-zoom-in" />
                                </PhotoView>
                              ) : (
                                <IconBarcode size={18} className="text-slate-400" />
                              )}
                            </div>
                          </td>
                          <td className="px-2 py-2 font-mono font-bold whitespace-nowrap">
                            <div className="flex items-center gap-1.5">
                              <span className={item.is_ready ? 'text-slate-900 dark:text-slate-100' : 'line-through text-slate-400'}>
                                {item.kode_item}
                              </span>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCopy(item.id, item.kode_item);
                                }}
                                className="text-slate-400 hover:text-amber-500"
                              >
                                {copyItemId === item.id ? (
                                  <IconCheck size={13} className="text-emerald-500" />
                                ) : (
                                  <IconCopy size={13} />
                                )}
                              </button>
                            </div>
                          </td>
                          <td className="px-2 py-2 font-semibold whitespace-nowrap">
                            {item.jenis_kategori?.nama_jenis || '-'}
                          </td>
                          <td className="px-2 py-2 whitespace-nowrap">{item.nomor_rak || '-'}</td>
                          <td className="px-2 py-2 whitespace-nowrap">
                            <span className="font-bold text-amber-600 dark:text-amber-400">{item.berat} gr</span>
                            <span className="text-slate-400 mx-1">|</span>
                            <span>{item.karat}k</span>
                          </td>
                          <td className="px-2 py-2 whitespace-nowrap">{item.ukuran || '-'}</td>
                          <td className="px-2 py-2 whitespace-nowrap text-slate-600 dark:text-slate-400">
                            {item.cabang?.nama_cabang || '-'}
                          </td>
                          {isOwnerAdminVerifikator && (
                            <td className="px-2 py-2 whitespace-nowrap font-bold text-slate-700 dark:text-slate-200">
                              Rp {numberWithCommas(item.harga_beli || item.harga_modal || 0)}
                            </td>
                          )}
                          <td className="px-2 py-2 text-center whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                            <div className="flex items-center justify-center gap-1">
                              <button
                                type="button"
                                onClick={() => getIdDelete(item.id)}
                                className="p-1 rounded bg-rose-500 hover:bg-rose-600 text-white cursor-pointer"
                                title="Hapus Item"
                              >
                                <IconTrash size={14} />
                              </button>
                            </div>
                          </td>
                          <td className="px-2 py-2 text-center" onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => handleCheckboxChange(e, item)}
                              className="checkbox checkbox-warning w-4 h-4 rounded-md border-slate-400 dark:border-slate-500 cursor-pointer"
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {items.length > 0 && (
                    <tfoot className="bg-amber-50/50 dark:bg-slate-800/80 border-t border-amber-200/60 dark:border-slate-700 font-semibold text-slate-800 dark:text-slate-200">
                      <tr>
                        <td colSpan={5} className="px-2 py-2 text-right">
                          Total Berat Halaman Ini:
                        </td>
                        <td className="px-2 py-2 font-bold text-amber-600 dark:text-amber-400 whitespace-nowrap">
                          {parseFloat(items.reduce((acc, curr) => acc + (Number(curr.berat) || 0), 0).toFixed(3))} gr
                        </td>
                        <td colSpan={isOwnerAdminVerifikator ? 4 : 3}></td>
                        <td className="px-2 py-2 text-center">
                          <input
                            type="checkbox"
                            checked={isCheckedAll}
                            onChange={handleCheckAll}
                            className="checkbox checkbox-warning w-4 h-4 rounded-md border-amber-400 dark:border-slate-500 cursor-pointer"
                            title="Pilih Semua"
                          />
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          )}
        </div>

        {/* ═══ Floating Action Bar for Bulk Operations ═══ */}
        {selectedItems.length > 0 &&
          !openPrintBandrol &&
          !openPindahBanyakBarang &&
          !openHapusBanyakBarang &&
          !openPindahBanyakBaki &&
          !openModalTransferToToko &&
          !openTransferAntarToko &&
          !openDetail && (
            <div
              ref={previewRef}
              className="fixed bottom-14 sm:bottom-16 left-1/2 -translate-x-1/2 z-40 w-[95%] sm:w-auto max-w-[620px] animate-[slideUp_0.3s_ease-out]"
            >
              {/* Selected Items Preview Drawer */}
              {showSelectedPreview && (
                <div className="mb-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md rounded-2xl shadow-2xl border border-amber-200/60 dark:border-slate-600 w-full sm:w-[420px] max-h-[280px] overflow-hidden flex flex-col mx-auto">
                  <div className="flex items-center justify-between px-3 sm:px-4 py-2 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-xs font-bold text-amber-700 dark:text-amber-400 uppercase tracking-wide">
                      Barang Terpilih ({selectedItems.length})
                    </span>
                    <button
                      type="button"
                      onClick={() => setShowSelectedPreview(false)}
                      className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 p-1"
                    >
                      <IconX size={16} />
                    </button>
                  </div>
                  <div className="overflow-y-auto flex-1 divide-y divide-slate-100 dark:divide-slate-700/50">
                    {selectedItems.map((item, idx) => (
                      <div
                        key={item.id}
                        className="flex items-center justify-between px-3 sm:px-4 py-2 hover:bg-amber-50/50 dark:hover:bg-slate-700/30 transition-colors"
                      >
                        <div className="flex items-center gap-2 min-w-0">
                          <span className="text-[10px] font-bold text-slate-400 w-4 text-center">{idx + 1}</span>
                          <div className="min-w-0">
                            <p className="text-xs font-bold text-slate-800 dark:text-slate-200 truncate">
                              {item.kode_item}
                            </p>
                            <p className="text-[10px] text-slate-400 truncate">
                              {item.jenis_kategori?.nama_jenis} • {item.berat}gr • {item.karat}k
                            </p>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            const filtered = selectedItems.filter((si) => si.id !== item.id);
                            setSelectedItems(filtered);
                            setSelectPindahItems(filtered);
                          }}
                          className="p-1 text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-lg transition-colors"
                          title="Hapus dari pilihan"
                        >
                          <IconX size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Action Bar Pills */}
              <div className="flex items-center gap-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md rounded-2xl shadow-2xl border border-amber-200/80 dark:border-slate-600 px-3 sm:px-4 py-2 w-full overflow-x-auto scrollbar-none">
                {/* Counter & Toggle Preview */}
                <button
                  type="button"
                  onClick={() => setShowSelectedPreview(!showSelectedPreview)}
                  className="flex items-center gap-1.5 pr-2.5 border-r border-slate-200 dark:border-slate-700 hover:opacity-80 transition-opacity flex-shrink-0 cursor-pointer"
                  title="Lihat barang yang dipilih"
                >
                  <span className="bg-amber-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                    {selectedItems.length}
                  </span>
                  <div className="flex flex-col text-left">
                    <span className="text-[11px] font-bold text-slate-700 dark:text-slate-200 leading-tight">
                      {totalBeratTerpilih} gr
                    </span>
                    <span className="text-[9px] text-slate-400 leading-none">
                      {showSelectedPreview ? 'Tutup' : 'Lihat'}
                    </span>
                  </div>
                  {showSelectedPreview ? (
                    <IconEyeOff size={14} className="text-slate-400 ml-0.5" />
                  ) : (
                    <IconEye size={14} className="text-amber-500 ml-0.5" />
                  )}
                </button>

                {/* Bulk Actions Buttons */}
                <div className="flex items-center gap-1.5 flex-1 min-w-0 overflow-x-auto scrollbar-none">
                  <button
                    type="button"
                    onClick={() => setOpenTransferAntarToko(true)}
                    className="flex items-center gap-1 px-2.5 py-1.5 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-xs font-bold rounded-xl shadow-xs whitespace-nowrap cursor-pointer"
                    title="Pindah Toko (Etalase)"
                  >
                    <IconBuildingStore size={14} />
                    <span>Pindah Toko</span>
                  </button>

                  <button
                    type="button"
                    onClick={() => setOpenModalTransferToToko(true)}
                    className="flex items-center gap-1 px-2.5 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-xs font-bold rounded-xl shadow-xs whitespace-nowrap cursor-pointer"
                    title="Transfer ke Cabang"
                  >
                    <IconTransferIn size={14} />
                    <span>Transfer</span>
                  </button>

                  {user !== 'admin' && (
                    <button
                      type="button"
                      onClick={() => setOpenPindahBanyakBarang(true)}
                      className="flex items-center gap-1 px-2.5 py-1.5 bg-blue-500 hover:bg-blue-600 text-white text-xs font-bold rounded-xl shadow-xs whitespace-nowrap cursor-pointer"
                      title="Pindah Barang"
                    >
                      <IconTransferOut size={14} />
                      <span>Pindah</span>
                    </button>
                  )}

                  {['admin', 'owner', 'operator', 'operator_toko', 'verifikator', 'kepala_toko'].includes(user) && (
                    <button
                      type="button"
                      onClick={() => setOpenHapusBanyakBarang(true)}
                      className="flex items-center gap-1 px-2.5 py-1.5 bg-rose-500 hover:bg-rose-600 text-white text-xs font-bold rounded-xl shadow-xs whitespace-nowrap cursor-pointer"
                      title="Hapus Banyak Barang"
                    >
                      <IconTrash size={14} />
                      <span>Hapus</span>
                    </button>
                  )}

                  {user !== 'admin' && (
                    <button
                      type="button"
                      onClick={() => setOpenPindahBanyakBaki(true)}
                      className="flex items-center gap-1 px-2.5 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-bold rounded-xl shadow-xs whitespace-nowrap cursor-pointer"
                      title="Pindah Baki Banyak"
                    >
                      <IconRefresh size={14} />
                      <span>Baki</span>
                    </button>
                  )}

                  <button
                    type="button"
                    onClick={() => {
                      if (selectedItems.length > 10) {
                        toast.error('Maksimal 10 item untuk cetak bandrol');
                        return;
                      }
                      setOpenPrintBandrol(true);
                    }}
                    className="flex items-center gap-1 px-2.5 py-1.5 bg-slate-700 hover:bg-slate-800 text-white text-xs font-bold rounded-xl shadow-xs whitespace-nowrap cursor-pointer"
                    title="Print Bandrol"
                  >
                    <IconPrinter size={14} />
                    <span>Print</span>
                  </button>
                </div>

                {/* Cancel All Selection */}
                <div className="pl-2 border-l border-slate-200 dark:border-slate-700 flex-shrink-0">
                  <button
                    type="button"
                    onClick={resetSelectPindahItems}
                    className="p-1.5 text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-xl transition-colors cursor-pointer"
                    title="Batal Pilih Semua"
                  >
                    <IconX size={15} />
                  </button>
                </div>
              </div>
            </div>
          )}

        {/* ═══ Sticky Bottom Pagination Bar ═══ */}
        <div className="fixed bottom-0 left-0 right-0 z-20 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-amber-100 dark:border-slate-800 px-3 sm:px-6 py-2.5 transition-colors">
          <div className="flex items-center justify-between max-w-7xl mx-auto gap-2">
            {/* Left: Summary text */}
            <div className="text-xs text-slate-500 dark:text-slate-400 hidden sm:block">
              Menampilkan <span className="font-bold text-slate-800 dark:text-slate-200">{items.length}</span> dari{' '}
              <span className="font-bold text-amber-600 dark:text-amber-400">{jmlBarang}</span> total barang
            </div>

            {/* Center/Right: Page navigation */}
            <div className="flex items-center gap-2 ml-auto">
              <span className="text-xs font-semibold text-slate-500 dark:text-slate-400 flex items-center gap-1">
                Hal
                <input
                  type="text"
                  value={pageInput}
                  onChange={(e) => setPageInput(e.target.value)}
                  onBlur={jumpToPage}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      jumpToPage();
                      e.target.blur();
                    }
                  }}
                  className="w-10 h-7 text-center font-bold text-amber-700 dark:text-amber-400 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none focus:border-amber-400"
                />
                dari <span className="font-bold text-slate-700 dark:text-slate-300">{lastPage}</span>
              </span>

              <div className="flex items-center gap-1">
                <button
                  type="button"
                  onClick={prevPage}
                  disabled={currentPage <= 1}
                  className="p-1.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:border-amber-400 cursor-pointer transition-all"
                  title="Halaman Sebelumnya"
                >
                  <IconChevronLeft size={16} />
                </button>
                <button
                  type="button"
                  onClick={nextPage}
                  disabled={currentPage >= lastPage}
                  className="p-1.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:border-amber-400 cursor-pointer transition-all"
                  title="Halaman Berikutnya"
                >
                  <IconChevronRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </Layouts>
  );
}

export default ListItemAdminV2;
